export default {"src":"/_next/static/media/Personalized.eab21e01.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};